import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeading } from "@/components/PackSelection";

export const faqs = [
  {
    q: "Quel pack choisir pour commencer ?",
    a: "Le Pack Découverte (10 produits / 100 €) permet de faire ses premiers pas. Le Pack Essentiel (15 produits / 150 €) offre une sélection plus large. Le Pack Pro (30 produits / 300 €) propose la sélection la plus complète et un stock plus important. Le choix dépend simplement de votre budget et de votre projet.",
  },
  {
    q: "Puis-je revendre les produits ?",
    a: "La revente doit respecter les règles applicables à votre situation et à la réglementation en vigueur. Il vous appartient de vérifier les conditions qui s'appliquent à votre cas avant de développer une activité de revente.",
  },
  {
    q: "Puis-je commencer en tant que particulier ?",
    a: "La revente occasionnelle peut être possible en tant que particulier. En revanche, une activité habituelle et exercée dans un objectif lucratif peut constituer une activité commerciale nécessitant un statut et des démarches adaptés.",
  },
  {
    q: "Les revenus sont-ils garantis ?",
    a: "Non. Aucun revenu n'est garanti. Les résultats dépendent notamment des ventes réalisées, de la clientèle et des conditions de revente.",
  },
  {
    q: "Est-ce une vente pyramidale ?",
    a: "Non. Le modèle repose sur la vente effective de produits et non sur la rémunération du recrutement de personnes, sous réserve que le fonctionnement réel du programme corresponde à cette présentation.",
  },
  {
    q: "Puis-je payer en plusieurs fois ?",
    a: "Le paiement s'effectue en une fois, de manière sécurisée par carte bancaire au moment de la commande. Seules les modalités de paiement réellement disponibles sur le site sont proposées lors du règlement.",
  },
];

export const FaqSection = () => (
  <section id="faq" className="bg-[var(--oz-bg-2)] scroll-mt-20">
    <div className="px-4 sm:px-8 lg:px-16 max-w-4xl mx-auto py-16 md:py-24">
      <SectionHeading eyebrow="Questions fréquentes" title="Vos questions, nos réponses" />
      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-accordion-item-${i}`}
            className="bg-white rounded-2xl border border-[var(--oz-border)] px-5 sm:px-6 overflow-hidden"
          >
            <AccordionTrigger className="text-left font-serif text-lg text-[var(--oz-text)] hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-[var(--oz-muted)] leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
